
import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const loadPath = process.env.PUBLIC_URL + '/locales/{{lng}}/{{ns}}.json';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: loadPath,
            // Add request options to help with debugging
            requestOptions: {
                cache: 'no-cache'
            }
        },
        lng: "en",
        fallbackLng: 'en',
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for React as it escapes by default
        },
    });

export default i18n;
